import { isly } from "isly";
import { Date } from "../Date";
export var Month;
(function (Month) {
    var _a;
    _a = isly
        .string(value => {
        const match = /^(\d{4})-(\d{2})$/.exec(value);
        return !!match && Date.Year.is(match[1]) && Date.Month.is(match[2]);
    }, "YYYY-MM")
        .rename("isoly.Month")
        .describe("ISO 8601 month in the format YYYY-MM.")
        .bind(), Month.type = _a.type, Month.is = _a.is, Month.flawed = _a.flawed;
    function now() {
        return from(Date.now());
    }
    Month.now = now;
    function from(date) {
        return date.substring(0, 7);
    }
    Month.from = from;
    function next(month, months = 1) {
        return from(Date.nextMonth(getDay(month, 1), months));
    }
    Month.next = next;
    function previous(week, months = 1) {
        return next(week, -months);
    }
    Month.previous = previous;
    function first(month) {
        return getDay(month, 0);
    }
    Month.first = first;
    function last(month) {
        return getDay(month, length(month) - 1);
    }
    Month.last = last;
    function getYear(month) {
        return Number.parseInt(month.substring(0, 4));
    }
    Month.getYear = getYear;
    function getMonth(month) {
        return Number.parseInt(month.substring(5, 7));
    }
    Month.getMonth = getMonth;
    function length(month) {
        return Date.getDay(Date.lastOfMonth(getDay(month, 0)));
    }
    Month.length = length;
    function getDay(month, day) {
        return `${month}-${(day + 1).toString().padStart(2, "0")}`;
    }
    Month.getDay = getDay;
    function getDays(month) {
        return [...Array(length(month)).keys()].map(day => getDay(month, day));
    }
    Month.getDays = getDays;
})(Month || (Month = {}));
//# sourceMappingURL=index.js.map